// extracted by mini-css-extract-plugin
export var boldText = "_3g-4";
export var checkboxContainer = "_3g-6";
export var closeIcon = "_3g-g";
export var container = "_3g-0";
export var drawer = "_3g-8";
export var drawerContent = "_3g-9";
export var extraSmallText = "_3g-5";
export var fulfillmentGroupTable = "_3g-e";
export var largeText = "_3g-3";
export var loadingSpinnerContainer = "_3g-h";
export var mediumText = "_3g-2";
export var narrow = "_3g-f";
export var notificationLink = "_3g-j";
export var packageCheckIconContainer = "_3g-7";
export var slideoutHeaderContainer = "_3g-a";
export var slideoutModal = "_3g-c";
export var stickyHeaderWrapper = "_3g-b";
export var table = "_3g-i";
export var tableContainer = "_3g-d";
export var tertiaryText = "_3g-1";